'use client';

import { ApolloProvider as BaseApolloProvider } from '@apollo/client';
import { useEffect, useState } from 'react';

import { createApolloClient } from '@/lib/apollo/client';

type ApolloProviderClientProps = {
  accessToken?: string;
  children: React.ReactNode;
  organisationId?: string;
};

export const ApolloProviderClient: React.FC<ApolloProviderClientProps> = ({
  accessToken = '',
  children,
  organisationId = '',
}) => {
  const [client, setClient] = useState(() => createApolloClient({ accessToken, organisationId }));

  useEffect(() => {
    setClient(createApolloClient({ accessToken, organisationId }));
  }, [accessToken, organisationId]);

  return <BaseApolloProvider client={client}>{children}</BaseApolloProvider>;
};
